import { Autocomplete, TextField } from '@mui/material';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '.';
import { FieldErrors } from './FieldErrors';

type AutocompleteOption = {
  value: string;
  label: string;
};

type AutocompleteFieldProps = {
  label: React.ReactNode;
  options: AutocompleteOption[];
  loading?: boolean;
};

// Searchable single-select. Unlike SelectField (a flat dropdown), the user can
// type to filter, so it stays usable when there are many options.
export const AutocompleteField = (props: AutocompleteFieldProps) => {
  const { label, options, loading } = props;
  const field = useFieldContext<string | undefined>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );
  const showError =
    (field.state.meta.isTouched || hasTriedToSubmit) &&
    field.state.meta.errors.length > 0;
  const selected = options.find((o) => o.value === field.state.value) ?? null;

  return (
    <Autocomplete
      fullWidth
      options={options}
      loading={loading}
      value={selected}
      onChange={(_event, newValue) => field.handleChange(newValue?.value)}
      onBlur={field.handleBlur}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={showError}
          helperText={<FieldErrors meta={field.state.meta} />}
        />
      )}
    />
  );
};
